import { render, staticRenderFns } from "./PricePill.vue?vue&type=template&id=40610b77&"
import script from "./PricePill.vue?vue&type=script&lang=js&"
export * from "./PricePill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports